import MessageWindow from "./chatframe/MessagingWindow";
import CIApp from "./CiApp";
import { Timeout } from "./util/Misc";
import { addOrRemoveFrameAria, loadScript } from "./chatframe/Utils";

const chatDivID = "nuanMessagingFrame";
const frameID = "inqChatStage";
const cssName = "nuance-chat";
const configName = "uiconfig.json";

/**
 * path where webpack will look for lazyloading the webpack chunks that are created while compilation, this value is set on the fly
 * to the lazy loading webpack import statement
 * @link https://webpack.js.org/guides/lazy-loading/
 * @link https://webpack.js.org/guides/public-path/
 * @type {string}
 * @private
 */
__webpack_public_path__ = `${Inq.urls.mediaLaunchCiURL}/`;

/**
 * @class MessagingApp
 * Application class that creates the Outer div which holds the Messaging/chat UI. This div is adopted to the parent document
 */
class MessagingApp {
    chatEl: any;

    SDKinstance: any;

    config: {chatDivID: string; frameID: string; frameW?: string; frameH?: string;};

    ciAppInstance: any;

    doc: Document;

    messageWindow: any;

    uiConfig: any;

    pluginInstance: any;

    constructor() {
        this.chatEl = null;
        /* global Inq */
        this.SDKinstance = Inq.FlashPeer.getSDKInst();
        this.config = {
            chatDivID,
            frameID,
        };
        this.createMessagingFrame();
        Inq.EVM.addListener({
            onChatClosed: () => {
                this.onChatClosed();
            },
        });
    }

    /**
     * Creates the instance of  Messaging UI class
     * @return {CIApp}
     */
    getCIAppInstance() {
        if (!this.ciAppInstance) {
            /* global v3Lander,FrameBridge */
            this.ciAppInstance = new CIApp(v3Lander.isWebSDK ? FrameBridge : this);
        }
        return this.ciAppInstance;
    }

    /**
     * Creates the outer div and adopts to parent document
     */
    createMessagingFrame() {
        MessagingApp.handleLegacyCallbacks();

        if (v3Lander.isWebSDK) {
            return;
        }

        this.doc = window.parent.document;
        this.injectStyleSheet(this.SDKinstance.getSkinDynamicAssetsPath(), this.doc, cssName);
        const div = this.doc.getElementById(chatDivID);
        div.classList.add("floating-nuan-chat");
        div.style.cssText = "z-index:9999999;height:1px;width:1px;"
            + "border-style: none;border-width: 0px;";
        this.chatEl = div;
        const frame = this.chatEl.querySelector(`#${frameID}`);
        frame.style.cssText = "";
        addOrRemoveFrameAria(true, frame);
        const sDiv = document.createElement("div");
        sDiv.setAttribute("id", "si-app");
        document.body.appendChild(sDiv);
    }

    onChatClosed() {
        if (this.messageWindow) {
            this.messageWindow.clear();
            this.messageWindow = null;
        }

        if (this.ciAppInstance) {
            // this.ciAppInstance.onDestroyFrame()
        }
    }

    /**
     * injecting chat css from the theme folder
     */
    injectStyleSheet(path, doc, cssName) { // eslint-disable-line class-methods-use-this,no-shadow
        const ss = doc.styleSheets;

        for (let i = 0, max = ss.length; i < max; i++) {
            if (ss[i].href && ss[i].href.indexOf(cssName) !== -1) {
                return;
            }
        }

        const link = doc.createElement("link");
        link.setAttribute("rel", "stylesheet");
        link.type = "text/css";
        link.href = `${path + cssName}.css`;
        doc.head.appendChild(link);
    }

    loadConfig(path, name, cb) { // eslint-disable-line class-methods-use-this
        const _loaderConfig = new com.inq.net.URLLoader();
        const _requestConfig = new com.inq.net.URLRequest(path + name);
        _loaderConfig.addEventListener(com.inq.events.Event.COMPLETE, () => {
            if (_loaderConfig.data) {
                cb(_loaderConfig.data);
            } else {
                throw new Error("uiconfig.json is not available for this theme");
            }
        });
        _loaderConfig.load(_requestConfig);
    }

    /**
     * initiating the rendering of chat UI , CIApp class holds the logic for rendering chat UI
     */
    showMessagingFrame(pcsID) {
        const theme = this.SDKinstance.getThemeInfo();
        const path = this.SDKinstance.getSkinDynamicAssetsPath();
        this.injectStyleSheet(path, document, "chatui");
        this.loadConfig(theme.skinPath, configName, data => {
            this.uiConfig = data;
            this.uiConfig.pcsID = pcsID;
            this.uiConfig.skinPath = theme.skinPath;

            if (data.skinConfig) {
                this.config.frameW = data.skinConfig.frameWidth;
                this.config.frameH = data.skinConfig.frameHeight;
            }

            if (data.richContentCSSStyle) {
                this.injectStyleSheet(path, document, data.richContentCSSStyle);
            }

            if (!this.messageWindow) {
                if (this.ciAppInstance) {
                    this.ciAppInstance.onReinitFrame(this);
                }
                /**
                 *
                 * @type {MessageWindow} messageWindow
                 */
                this.messageWindow = new MessageWindow(this);
            }

            if (this.getCIAppInstance().checkAndMinimizeOnNewPageLoad(theme.minimized)) {
                theme.minimized = {
                    state: true,
                    count: 0,
                };
            }

            this.messageWindow.render(theme);
            this.getCIAppInstance().onCreateFrame();

            if (this.uiConfig.minimizedStateC2CPlugin) {
                loadScript(path + this.uiConfig.minimizedStateC2CPlugin);
            }
        });
    }

    getUIConfig() {
        return this.uiConfig;
    }

    getSDKInstance() {
        return this.SDKinstance;
    }

    /**
     * returns the element that holds the Messaging UI
     * @return {HTMLElement}
     */
    getStage() {
        return this.chatEl;
    }

    onRestoredClicked() {
        if (this.messageWindow) {
            this.messageWindow.setVisible(true);
        }
    }

    minimizeFrame() {
        if (this.messageWindow) {
            this.messageWindow.minimize();
        }

        if (this.pluginInstance) {
            this.pluginInstance.setMinimized(this.messageWindow.minimizedCount);
        }
    }

    messageOnMinimized(msgObj) {
        this.messageWindow.minimizedCount += 1;

        if (this.pluginInstance) {
            this.pluginInstance.messageOnMinimzed(this.messageWindow.minimizedCount, msgObj);
        }
    }

    onVirtualKeyboardOpen() {
        this.messageWindow.onVirtualKeyboardOpen();
    }

    onVirtualKeyboardHidden() {
        this.messageWindow.onVirtualKeyboardHidden();
    }

    showPostChatSurvey(pcsID, data) {
        this.ciAppInstance.displayPostChatSurvey(pcsID, data);
    }

    pushToFrameSet(href, target) { // eslint-disable-line class-methods-use-this
        com.inq.flash.client.control.FlashPeer.PushToFrameset(href, target);
    }

    setPluginInstance(c2cInstance) {
        this.pluginInstance = c2cInstance;

        if (this.messageWindow) {
            if (this.messageWindow.minimized) {
                if (this.SDKinstance.getThemeInfo().embedded) {
                    this.onRestoredClicked();
                } else {
                    c2cInstance.setMinimized(this.messageWindow.minimizedCount);
                }
            } else if (c2cInstance.displayChatFab && !this.SDKinstance.getThemeInfo().embedded) {
                c2cInstance.displayChatFab();
            }
        }
    }

    getPluginInstance() {
        return this.pluginInstance;
    }

    addDrag(el) {
        const theme = this.SDKinstance.getThemeInfo();
        this.messageWindow.addDragElement(theme, el);
    }

    isFullScreen() {
        return this.messageWindow.isPhone();
    }

    isTablet() {
        this.messageWindow.isTablet();
    }

    static handleLegacyCallbacks() {
        /**
         * toHandle cobrowse minimize and restore from cbc.js
         */
        if (com.inq.flash.client.control.MinimizeManager) {
            com.inq.flash.client.control.MinimizeManager.actionMinimize = function () {
                this.ciAppInstance.minimize();
            };

            com.inq.flash.client.control.MinimizeManager.actionRestore = function () {
                this.onRestoredClicked();
            };
        }

        if (com.inq.flash.client.chatskins.SkinControl) {
            com.inq.flash.client.chatskins.SkinControl.actionRestoreAndExitChat = function () {
                this.onRestoredClicked();
                Timeout.set(() => {
                    this.SDKinstance.closeChat();
                }, 1000);
            };
        }
    }

    /**
     * Exposing an API, so that BR can override the appString props dynamically
     * @param {string} propertName
     * @param {string} value
     */
    setAppString(propertName, value) {
        /*
         * modifying the uiconfig.json so that updated string in present in uiConfig.json,
         * view components can either directly access the property from uiConfig.json or from CIAPP instance.
         * Updating both places so that both CIApp instance and UIConfig has the same value
         */
        this.getUIConfig().appStringProps[propertName] = value;

        if (this.getCIAppInstance().hasOwnProperty(propertName)) {
            this.getCIAppInstance()[propertName] = value;
        }
    }
}

/**
 *
 * @type {MessagingApp}
 */
window.messagingApp = new MessagingApp();